import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

// Note: For online ordering, authentication is not required (all APIs are public)
// App settings and preferences are now restaurant-scoped and loaded dynamically
// when a restaurant slug is available from the URL

export const store = configureStore({
  reducer: rootReducer,
  // No preloadedState needed - all state is restaurant-scoped and loaded on demand
});